var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-checkbox-group',{attrs:{"label":"Layers","stacked":"","options":_vm.layers},model:{value:(_vm.selectedLayers),callback:function ($$v) {_vm.selectedLayers=$$v},expression:"selectedLayers"}})}
var staticRenderFns = []

export { render, staticRenderFns }